/** 业务场景枚举 */
export enum BUSINESS_SCENE {
  jitang = 'jitang', // 积糖糖1
  wish = 'wish', //  心愿先生商城
  jingxuan = 'jingxuan', // 积糖精选
  art = 'art', //
  welfare = 'welfare', // 心愿福利商城
  shenjie = 'shenjie', // 神姐的奇妙小屋
  manicure = 'manicure', // 心愿先生美甲
}

/** 模拟用户token - 用于调试 */
export const mockUserToken = '0589d254729fbc1d7a9533ae6bfa3454759b26fd936566f64e503484a395bc26';

/** 当前业务场景 */
export let currentBusinessScene = BUSINESS_SCENE.jitang;

/** 获取环境文本 */
const switchCurrentBusinessSceneToText = (key: BUSINESS_SCENE) => {
  switch (key) {
    case BUSINESS_SCENE.wish:
      return `心愿先生商城`;
    case BUSINESS_SCENE.jingxuan:
      return `积糖精选`;
    case BUSINESS_SCENE.art:
      return `BLACKKITTY NAIL ART`;
    case BUSINESS_SCENE.shenjie:
      return `BLACKKITTY NAIL ART`;
    default:
      return `积糖糖1`;
  }
};

/** 通用url */
const COMMON_URL = {
  fetchApi: ['https://api.scmally.startcatcher.cn', 'https://api.mall.startcatcher.com'],
  // fetchApi: ['http://127.0.0.1:3000', 'https://api.mall.startcatcher.com'],
  // fetchApi: ['http://10.0.0.113:3000', 'https://api.mall.startcatcher.com'],
  // fetchApi: ['http://192.168.9.29:3000', 'https://api.mall.startcatcher.com'],
  motamoHost: ['https://testmatomo.startcatcher.cn', 'https://mt.startcatcher.com'],
};

/** 是否开发环境 */
export const isDevelopment = process.env.NODE_ENV === 'development';

const ENV_CONFIGS = {
  [BUSINESS_SCENE.jitang]: {
    appId: `"wxd641432b81c2b6d3"`,
    host: COMMON_URL.fetchApi[0],
    motamoHost: COMMON_URL.motamoHost[0],
    channel: ['snrq0k7ry49cni771gzr'],
    h5Host: 'https://testh5.scmally.startcatcher.cn',
    uniH5Host: 'https://h5.startcatcher.cn',
  },
  [BUSINESS_SCENE.wish]: {
    appId: `"wxe2d6c95d7852ac16"`,
    host: COMMON_URL.fetchApi[1],
    motamoHost: COMMON_URL.motamoHost[1],
    channel: ['BSF9TN1FWA1YXAGB'],
    h5Host: 'https://mini.startcatcher.com',
    uniH5Host: '',
  },
  [BUSINESS_SCENE.jingxuan]: {
    appId: `"wx2fbb896b15dfdc02"`,
    host: COMMON_URL.fetchApi[0],
    motamoHost: COMMON_URL.motamoHost[0],
    channel: ['af2097492482c7fd1092'],
    h5Host: '',
    uniH5Host: '',
  },
  [BUSINESS_SCENE.art]: {
    appId: `"wx84a9a5c108d26c60"`,
    host: COMMON_URL.fetchApi[1],
    motamoHost: COMMON_URL.motamoHost[1],
    channel: ['VFGBU5ESJZIR2YDN'],
    h5Host: '',
    uniH5Host: '',
  },
  [BUSINESS_SCENE.shenjie]: {
    appId: `"wx525e1c65b16ca30c"`,
    host: COMMON_URL.fetchApi[1],
    motamoHost: COMMON_URL.motamoHost[1],
    channel: ['KNCYKIESMGKEXXID'],
    h5Host: '',
    uniH5Host: '',
  },
  [BUSINESS_SCENE.welfare]: {
    appId: `"wxa9eaab830f6ff9e5"`,
    host: COMMON_URL.fetchApi[1],
    motamoHost: COMMON_URL.motamoHost[1],
    channel: ['SMXUVIVDOTBQSMTD'],
    h5Host: '',
    uniH5Host: '',
  },
  [BUSINESS_SCENE.manicure]: {
    appId: `"wx4ea517e38ec0b924"`,
    host: COMMON_URL.fetchApi[1],
    motamoHost: COMMON_URL.motamoHost[1],
    channel: ['VFGBU5ESJZIR2YDN'],
    h5Host: '',
    uniH5Host: '',
  },
};

/**
 * 处理渠道
 * @param channel - 渠道配置列表
 * @returns
 */
const channelHandler = (channel: string[]) => {
  return channel[0];
};

export const sceneConfig: any = ENV_CONFIGS[currentBusinessScene];

export default (() => {
  console.log(
    `【 ${switchCurrentBusinessSceneToText(currentBusinessScene)} - ${process.env.NODE_ENV} 】`
  );

  return {
    ...sceneConfig,
    channel: channelHandler(sceneConfig.channel),
  };
})();

/** 全局功能开关 */
export const GLOBAL_SWITCH = {
  // 模拟接口数据
  MOCK_FETCH: false,
  // 签到
  SIGN_IN: true,
};
